import React from "react";
import Amazon from "../../img/Amazon.png";
import Etsy from "../../img/Etsy.png";
import Aliexpress from "../../img/Aliexpress.png";
import Joom from "../../img/Joom.png";
import qoo10 from "../../img/qoo10.png";
import Disney from "../../img/Disney.png";

export default function Partner() {
  return (
    <>
      <div className="h-auto py-8 lg:py-16 mx-auto max-w-screen-xl px-4">
        <h2 className="mb-8 lg:mb-16 text-3xl font-extrabold tracking-tight leading-relaxed text-center  md:text-4xl">
          Our Partner Companies
        </h2>
        <div className="grid grid-cols-2 gap-8 text-black sm:gap-12 md:grid-cols-3 lg:grid-cols-6 ">
          <a href="/" className="flex justify-center items-center">
            <img src={Amazon} className="mr-3 h-6 sm:h-9" alt="Flowbite Logo"></img>
          </a>
          <a href="/" className="flex justify-center items-center">
            <img src={Etsy} className="mr-3 h-10 sm:h-10" alt="Flowbite Logo"></img>
          </a>
          <a href="/" className="flex justify-center items-center">
            <img src={Aliexpress} className="mr-3 h-6 sm:h-8" alt="Flowbite Logo"></img>
          </a>

          <a href="/" className="flex justify-center items-center">
            <img src={Joom} className="mr-3 h-7 sm:h-7" alt="Flowbite Logo"></img>
          </a>
          <a href="/" className="flex justify-center items-center">
            <img src={qoo10} className="mr-3 h-6 sm:h-9" alt="Flowbite Logo"></img>
          </a>
          <a href="/" className="flex justify-center items-center">
            <img src={Disney} className="mr-3 h-16 sm:h-16" alt="Flowbite Logo"></img>
          </a>
        </div>
      </div>
    </>
  );
}
